<!-- CusSiwper -->
<template>
  <van-swipe
    :autoplay="3000"
    :height="250"
  >
    <van-swipe-item
      v-for="(image, index) in list"
      :key="index"
      class="cus_swiper_item"
    >
      <img
        class="cus_img"
        v-lazy="`${apiObj.VUE_APP_BASE_CDN}${isrank ? image.url : image}`"
      />
      <!-- v-lazy="`${apiObj.VUE_APP_BASE_CDN}${isrank ? image.url : image}!/fh/250`" -->
    </van-swipe-item>
  </van-swipe>
</template>

<script>
import Vue from 'vue'
import { Swipe, SwipeItem, Lazyload } from 'vant'
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Lazyload)

import apiObj from '@a/js/api.js'
export default {
  name: 'CusSiwper',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    isrank: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      apiObj
    };
  },

  components: {},

  methods: {

  },

  mounted() {

  },
}
</script>
<style lang='less' scoped>
.cus_swiper_item {
  overflow: hidden;
  font-size: 0;
  .cus_img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
}
</style>